import { useCallback } from 'react';
import { useRequest } from 'ahooks';
import { Options } from 'ahooks/lib/useRequest/src/types';
import { AxiosResponse } from 'axios';

import { apiDelete } from 'api';

import { useGetHeaders } from 'hooks';

import {
  IApiHookRequestParams,
  IApiRequestParams,
  TRequestCallback,
  TResponse,
} from 'types';

import { handleRequest } from './handleRequest';

export const useDeleteRequest = <R>(opts?: IApiHookRequestParams<R, IApiRequestParams>): [
  request: TRequestCallback,
  response: TResponse<R, IApiRequestParams>
] => {
  const {
    url,
    options,
    baseURL,
    queryParams,
  } = opts || {};

  const {
    run,
    data,
    ...rest
  } = useRequest<AxiosResponse<R>, [IApiRequestParams]>(
    apiDelete,
    { ...options, manual: true } as Options<AxiosResponse<R>, [IApiRequestParams]>,
  );

  const headers = useGetHeaders();

  const handleDeleteRequest = useCallback(handleRequest({
    run,
    url,
    baseURL,
    headers,
    queryParams,
  }), [url, headers]);

  return [
    handleDeleteRequest,
    {
      ...rest,
      data: data?.data,
    } as TResponse<R, IApiRequestParams>,
  ];
};
